import { CreateLoanRow } from '@willow/types-iso';

import { formatResponseForFlatfile } from '../../shared/formatResponse';
import { makeValidator } from '../../shared/makeValidator';
import {
  CreateLoanCrossFieldParserOptions,
  CrossFieldParserContext,
  getCreateLoanCrossFieldParser,
} from './CreateLoanCrossFieldParser';
import { getCreateLoanWarningParser } from './CreateLoanWarningParser';

export type ValidateCreateLoanOptions = CreateLoanCrossFieldParserOptions;

export const validateCreateLoan = (
  context: CrossFieldParserContext,
  allowPaymentDueDateAnyDayOfMonth: boolean,
  options?: ValidateCreateLoanOptions,
) =>
  makeValidator({
    FieldParser: CreateLoanRow,
    CrossFieldParser: getCreateLoanCrossFieldParser(context, allowPaymentDueDateAnyDayOfMonth, options),
    WarningParser: getCreateLoanWarningParser(context),
    // The API path must not coerce the literal string "null" to empty, so a borrower whose
    // real name is "Null" boards. The CSV/flatfile path keeps coercing (empty spreadsheet
    // cells arriving as "null").
    coerceNullString: context !== 'api',
  });

export const validateCreateLoanForFlatfile = (
  data: any,
  allowPaymentDueDateAnyDayOfMonth: boolean,
  options?: ValidateCreateLoanOptions,
) => {
  const parsed = validateCreateLoan('csv', allowPaymentDueDateAnyDayOfMonth, options)(data);
  return formatResponseForFlatfile(parsed, 'loanId');
};
